"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var GenericTreeReportHeader_1 = require("../model/GenericTreeReportHeader");

var AbstractReportConverter_1 = require("./AbstractReportConverter");

var GenericTreeReportHeaderConverter =
/*#__PURE__*/
function (_AbstractReportConver) {
  _inherits(GenericTreeReportHeaderConverter, _AbstractReportConver);

  function GenericTreeReportHeaderConverter() {
    _classCallCheck(this, GenericTreeReportHeaderConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericTreeReportHeaderConverter).apply(this, arguments));
  }

  _createClass(GenericTreeReportHeaderConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var header = new GenericTreeReportHeader_1.GenericTreeReportHeader(source.id, source.tree, this.mapToObj(source.treeMapping, conversions), source.completed, source.error, source.params);
      return header.copy('created', conversions.toDate(source.created));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        id: source.id,
        tree: this.ensureInterfaceDataOnly(source.tree),
        treeMapping: this.mapToDoc(source.treeMapping, conversions),
        completed: source.completed,
        error: source.error,
        params: source.params,
        created: conversions.fromDate(source.created)
      };
    }
  }, {
    key: "ensureInterfaceDataOnly",
    value: function ensureInterfaceDataOnly(node) {
      var _this = this;

      var a = {
        id: node.id,
        parentId: node.parentId,
        children: node.children.map(function (ch) {
          return _this.ensureInterfaceDataOnly(ch);
        }),
        level: node.level
      };
      return a;
    }
  }, {
    key: "mapToObj",
    value: function mapToObj(source, conversions) {
      var map = immutable_1.Map();
      Object.keys(source).forEach(function (key) {
        map = map.set(key, source[key]);
      });
      return map;
    }
  }, {
    key: "mapToDoc",
    value: function mapToDoc(source, conversions) {
      var doc = {};
      source.forEach(function (val, key) {
        doc = Object.assign(doc, _defineProperty({}, key, val));
      });
      return doc;
    }
  }]);

  return GenericTreeReportHeaderConverter;
}(AbstractReportConverter_1.AbstractReportConverter);

exports.GenericTreeReportHeaderConverter = GenericTreeReportHeaderConverter;